<template>
	<div>
		<!-- import header -->
		<app-header/>

		<!-- pages display -->
		<div class="container-fluid">
			<div class="row">
				<!-- mobile view for sidebar -->
				<div class="col-12 bg-light d-sm-none py-1">
					<div @click.prevent="showPortalMenu = !showPortalMenu" 
						class="card border-dark clickable text-center text-uppercase font-weight-bold py-1">
						<span v-if="!showPortalMenu" class="text-dark-green">Show Portal Menu <i class="fas fa-caret-down"></i> </span>
						<span class="text-danger" v-else>Hide Portal Menu <i class="fas fa-caret-up"></i></span>
					</div>
					<app-sidebar v-if="showPortalMenu" @emitHidePortalMenu="showPortalMenu = false" class="mt-2"/>
				</div>
				
				<!-- desktop view for sidebar -->
				<div class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-xs-4 col-12 p-0 bg-light h-100 d-none d-sm-block">
					<!-- import sidebar -->
					<app-sidebar/>
				</div>
				<div class="col-xl-9 col-lg-9 col-md-9 col-sm-8 col-xs-12 col-12 p-0 h-100">
					<!-- display pages -->
					<slot/>
				</div>
			</div>
		</div>

		<!-- import footer -->
		<app-footer/>
	</div>
</template>

<script>
import Header from '@/components/general/shared/Header.vue'
import Sidebar from '@/components/shop/shared/Sidebar.vue'
import Footer from '@/components/general/shared/Footer.vue'

export default {
	name: "Shop",
	data() {
		return {
			showPortalMenu: false
		}
	},
	components: {
		appHeader: Header,
		appSidebar: Sidebar,
		appFooter: Footer
	}
}
</script>
